export const NavItems = [
  {
    title: 'Home',
    url: '/rewards/home',
  },
  {
    title: 'Stays',
    url: '/rewards/stays',
  },
  {
    title: 'Things to Do',
    url: '/caesars-palace',
  },
  {
    title: 'Offers',
    url: '/rewards/offers',
  },
  {
    title: 'Benefits',
    url: '/myrewards/earn-and-redeem',
  },
  {
    title: 'Support',
    url: 'https://caesarsrewards.custhelp.com/app/home/kw/',
  },
  {
    title: 'Account',
    url: '/rewards/profile',
  },
];
